import React from 'react';

import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';

import { Plus } from 'lucide-react';
import { PlannerPublishList } from './planner-publish-list';
import { useEnv } from '@/components/providers/env-provider';
import { hasPermission } from '@/utils/validation';
import { PUBLISH_PERMISSIONS } from '@/config/feature-permissions';
import { useUser } from '@/components/providers/user-provider';

export function PlannerPublish() {
  const [open, setOpen] = React.useState(false);

  const { env } = useEnv();
  const { role } = useUser();

  if (!hasPermission(PUBLISH_PERMISSIONS[env], role)) {
    return null;
  }

  const title = {
    production: 'Publish to Production',
    cte: 'Publish to CTE',
  };

  return (
    <Sheet open={open} onOpenChange={(open) => setOpen(open)}>
      <SheetTrigger asChild>
        <Button
          variant='default'
          className='gap-2 h-8 border-solid border-1 rounded p-4 light:border-white border-slate-800'
        >
          <Plus className='h-4 w-4' />
          <span>{title[env]}</span>
        </Button>
      </SheetTrigger>

      <SheetContent side={'bottom'}>
        <SheetHeader className='pb-4'>
          <SheetTitle>{title[env]}</SheetTitle>
          <SheetDescription>Select and publish your draft</SheetDescription>
        </SheetHeader>
        <PlannerPublishList open={open} setOpen={setOpen} publishToEnv={env} />
      </SheetContent>
    </Sheet>
  );
}
